<div
  class="header_container"
  id="header_container"
  [ngStyle]="{ display: !showHeader ? 'none' : 'flex' }"
>
  <div class="mobile_header" *ngIf="isMobileScreen">
    <button
      type="button"
      aria-label="mobile menu"
      class="burger-button"
      [matMenuTriggerFor]="mobileNoAuthMenu"
      (menuOpened)="menuOpened()"
      (menuClosed)="menuClosed()"
    >
      <mat-icon>{{ isMenuOpen ? 'close' : 'menu' }}</mat-icon>
    </button>

    <a routerLink="/" class="pinploy_logo_header">
      <img
        class="logo_in_header"
        src="{{ logo }}"
        alt="logo"
        width="130px"
        height="30px"
      />
    </a>

    <button style="background-color: transparent" aria-label="Opret opgave">
      <a
        routerLink="/opret"
        class="create_task_circle_cta_mobile"
        aria-label="Opret en opgave"
      >
        <mat-icon>add</mat-icon>
      </a>
    </button>

    <mat-menu
      #mobileNoAuthMenu="matMenu"
      yPosition="below"
      xPosition="after"
      style="border-radius: 0"
      class="mobile_nav_no_auth"
    >
      <button
        class="mobile_menu_item mobile_nav_items"
        aria-label="skift sprog"
        *ngIf="verticalLinkBoxComponent && currentTranslationLanguageTrigger"
        [matMenuTriggerFor]="verticalLinkBoxComponent?.menu"
        mat-menu-item
      >
        {{
          'COMPONENTS.HEADER.CATEGORIES'
            | translate: currentTranslationLanguageTrigger
        }}
      </button>
      <a
        class="mobile_menu_item mobile_nav_items"
        routerLink="/tilmeld"
        (click)="openAuthPage()"
        mat-menu-item
        id="signup"
      >
        {{
          'PLACEHOLDERS.LOGIN' | translate: currentTranslationLanguageTrigger
        }}
      </a>
      <a
        class="mobile_menu_item mobile_nav_items"
        routerLink="/tilmeld"
        (click)="openAuthPage()"
        id="login"
        mat-menu-item
      >
        {{
          'PLACEHOLDERS.SIGNUP' | translate: currentTranslationLanguageTrigger
        }}
      </a>
      <a class="mobile_menu_item" routerLink="/opgaver" mat-menu-item>
        <div class="mobile_nav_items">
          {{
            'PLACEHOLDERS.SEE_TASKS'
              | translate: currentTranslationLanguageTrigger
          }}
        </div>
      </a>
      <a
        class="mobile_menu_item"
        [href]="externalLinksService.getPageUrl('how-it-works')"
        mat-menu-item
      >
        <div class="mobile_nav_items">
          {{
            'PAGES.LANDING.HOW_1' | translate: currentTranslationLanguageTrigger
          }}
        </div>
      </a>
      <button
        class="mobile_menu_item gtm_happyhelper_refer_cleaning_mobile_menu"
        (click)="goToUserHappyHelper()"
        mat-menu-item
      >
        <div style="display: block" class="mobile_nav_items">
          {{
            'COMPONENTS.HEADER.HAPPYHELPER'
              | translate: currentTranslationLanguageTrigger
          }}
        </div>
      </button>
      <a
        class="mobile_menu_item"
        [href]="externalLinksService.getPageUrl('about-us')"
        mat-menu-item
      >
        <div class="mobile_nav_items">
          {{
            'COMPONENTS.HEADER.ABOUTUS'
              | translate: currentTranslationLanguageTrigger
          }}
        </div>
      </a>
      <a class="mobile_menu_item" routerLink="/hjaelp" mat-menu-item>
        <div class="mobile_nav_items">
          {{
            'COMPONENTS.SIDEBAR.ACCOUNT.FAQ'
              | translate: currentTranslationLanguageTrigger
          }}
        </div>
      </a>
      <a
        class="mobile_menu_item"
        [href]="externalLinksService.getPageUrl('skadegodtgoerelse')"
        mat-menu-item
      >
        <div class="mobile_nav_items">
          {{
            'PAGES.FAQ.FAQ_12.HEADER'
              | translate: currentTranslationLanguageTrigger
          }}
        </div>
      </a>
      <button class="mobile_menu_item" (click)="toggleLanguage()" mat-menu-item>
        <div style="display: block" class="mobile_nav_items">
          {{
            'COMPONENTS.HEADER.LANG_SWITCH'
              | translate: currentTranslationLanguageTrigger
          }}
          <img
            *ngIf="showLangImg"
            id="language_config_flag"
            height="20px"
            width="20px"
            [lazyLoad]="'COMPONENTS.HEADER.FLAG_ICON' | translate"
            [defaultImage]="defaultImage"
            alt="language flag"
          />
        </div>
      </button>
    </mat-menu>
  </div>

  <div class="desktop_header" *ngIf="!isMobileScreen">
    <div class="desktop_header_left">
      <a routerLink="/" class="pinploy_logo_header">
        <img
          class="logo_in_header"
          src="{{ logo }}"
          alt="logo"
          width="130"
          height="30px"
        />
      </a>

      <button class="call_to_action_create_task" routerLink="/opret">
        {{
          'COMPONENTS.HEADER.CREATE'
            | translate: currentTranslationLanguageTrigger
        }}
      </button>

      <app-vertical-link-box-component
        [currentTranslationLanguageTrigger]="currentTranslationLanguageTrigger"
      >
      </app-vertical-link-box-component>

      <a
        class="link link_how_to"
        [href]="externalLinksService.getPageUrl('how-it-works')"
      >
        {{
          'PAGES.LANDING.HOW_1' | translate: currentTranslationLanguageTrigger
        }}
      </a>
    </div>

    <div class="desktop_header_right">
      <a class="link" routerLink="/opgaver">
        {{
          'PLACEHOLDERS.SEE_TASKS'
            | translate: currentTranslationLanguageTrigger
        }}
      </a>

      <p class="link" id="sign-up-desktop" (click)="openAuthPage()">
        {{
          'PLACEHOLDERS.SIGNUP' | translate: currentTranslationLanguageTrigger
        }}
      </p>

      <p class="link" id="login-desktop" (click)="openAuthPage()">
        {{
          'PLACEHOLDERS.LOGIN' | translate: currentTranslationLanguageTrigger
        }}
      </p>

      <div class="language_select" [matMenuTriggerFor]="langDropdown">
        <img
          *ngIf="lang?.flag === 'dk'"
          alt="dansk"
          style="height: 15px; width: 15px"
          src="{{ environment.cloudFrontImgUrl }}/private/denmark.png"
          class="flag-icon flag-icon-{{ lang?.flag }}"
        />
        <img
          *ngIf="lang?.flag === 'gb'"
          alt="eng"
          style="height: 15px; width: 15px"
          src="{{ environment.cloudFrontImgUrl }}/private/united-kingdom.png"
          class="flag-icon flag-icon-{{ lang?.flag }}"
        />
        <mat-icon>arrow_drop_down</mat-icon>
      </div>

      <mat-menu #langDropdown="matMenu" [overlapTrigger]="false">
        <div
          class="select_row"
          *ngFor="let item of languages"
          (click)="updateLocalLanguage(item, true)"
        >
          <p>{{ item.name }}</p>
        </div>
      </mat-menu>
    </div>
  </div>
</div>
